module.exports = __webpack_public_path__ + "img/2.8b7804df.jpeg";